// extracted by mini-css-extract-plugin
export default {"icon":"AllDocumentsDisabledPopup__icon--22pKa","description":"AllDocumentsDisabledPopup__description--2EzlN","content":"AllDocumentsDisabledPopup__content--3yKOr"};